import { render } from "./Logo.vue?vue&type=template&id=d174dcdc"
const script = {}

import exportComponent from "/var/www/inv/inertia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__